import { Select } from "@/components/common/Select/Select";
import { socialMediaPlatformList } from "@/store/types/socialMediaSizePresets";
import { useSocialMediaPlatform } from "./useSocialMediaPlatform";
import { translateFunc } from "@/utils/translateFunc";

const SocialMediaPlatform = () => {
    const { platform, handleChange: handlePlatformChange } = useSocialMediaPlatform();

    return (
        <div className="flex flex-col gap-4 z-20">
            <Select
                options={Object.values(socialMediaPlatformList)}
                getOptionValue={(o) => o.name}
                value={platform}
                handleClick={handlePlatformChange}
                label={translateFunc("choose-the-social-media-platform")}
                getOptionLabel={(option) => option.name}
                testKey="social-media-platform"
            />
        </div>
    );
};
export default SocialMediaPlatform;
